import { styled, Theme } from '@mui/system';
import { Box, Stack } from '@mui/material';

import { MessageKind } from '../types';

export const MessageBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  padding: '20px',
});

export const MessageStack = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  gap: theme.spacing(1),
  overflowY: 'auto',
  flexGrow: 1,
}));

export const MessageBubble = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'kind',
})<{ kind: MessageKind }>(({ theme, kind }) =>
  getMessageBubbleStyles(theme, kind),
);

const getMessageBubbleStyles = (theme: Theme, kind: MessageKind) => {
  const baseStyles = {
    padding: theme.spacing(1, 2),
    borderRadius: 20,
    wordBreak: 'break-word' as const,
  };

  if (kind === 'BOT_MESSAGE')
    return {
      ...baseStyles,
      alignSelf: 'flex-start',
      backgroundColor: theme.palette.primary[800],
    };

  return {
    ...baseStyles,
    alignSelf: 'flex-end',
    backgroundColor: theme.palette.secondary[700],
  };
};
